import BrandLogo from './BrandLogo.js';

export {
    BrandLogo
};